import { Component, OnInit, TemplateRef, ViewChild, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
const config = require('../../../assets/config/development.js'); // config file to get the url
import { environment } from '../../../environments/environment';
import { RecommendationService } from '../questionnaire-residential/recommendation/recommendation.service';
import { ResidentialService } from '../questionnaire-residential/residential.service';
import { _ } from 'underscore';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { SnackbarComponent } from 'src/app/snackbar/snackbar.component';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignupComponent implements OnInit {
  userObj = {
    emailId: '',
    confirmEmailId: '',
    fName: '',
    lName: '',
    phone: '',
    password: '',
    confirmPassword: '',
  };
  captchaVerified = false;
  url = environment.api_url;
  resetCaptcha = false;
  model: any = {};
  // For captcha;
  mainCaptcha;
  c;
  evaTxt;
  selectedTxt;
  selectedId;
  confirmPassword;
  isPswdMatch = true;
  modalRef: BsModalRef;
  display = 'none';
  showPassword = false;
  user_bot = false;
  user_bot1 = false;
  passwordMismatch = false;
  disablebutton: false;
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'Delete',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
  ];
  private loadSignupResponses = {
    Error: this.getErrorResponseAPI.bind(this),
    Success: this.getSuccessResponseAPI.bind(this),
  };
  signUpResult: any;
  loadNavigationLinksForEnergyProviders = {
    OtherProviders: this.redirectUrlForOtherEnergyProviders.bind(this),
    Bulb: this.redirectUrlForBulbProvider.bind(this),
    ProntoPower: this.redirectUrlForProntoProvider.bind(this),
    Others: this.redirectUrlForNewSignup.bind(this),
  };

  loadNavigateByUrl = [
    { key: 'precontact', value: '/faq/contact-us' },
    { key: 'commercial', value: '/commercial' },
    { key: 'giveback', value: '/giveback' },
    { key: 'blog', value: '/blog' },
    { key: 'faq', value: '/faq' },
  ];
  selectedProduct: any;
  providerContact: any;
  userResponses: any;
  private loadServiceTypeObject = {
    NewService: this.assignServiceTypeValuesForNewService.bind(this),
    SwitchingProviders:
      this.assignServiceTypeValuesForStandardSwitch.bind(this),
  };
  confirmationNumber: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  statusText: any;
  flag: boolean = true;

  public resolved(captchaResponse: string) {
    if (captchaResponse) {
      this.captchaVerified = true;
    }
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private recommendationService: RecommendationService,
    private activeRouter: ActivatedRoute,
    private residentialService: ResidentialService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private snackBar: MatSnackBar,
    private _renderer2: Renderer2,
  ) {
    const self = this;
  }

  ngOnInit() {
    this.loadScript();
    this.selectedProduct = this.assignSelectedProduct();
    if (this.selectedProduct) this.getProviderInfo();
    this.captcha();
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.validatePhone();
    this.getConfirmationNumber();
  }
  getConfirmationNumber() {
    this.residentialService
      .autoGenerateConfirmationNumber()
      .subscribe((res: any) => {
        this.confirmationNumber = `${this.selectedProduct.energy_provider.charAt(
          0
        )}${String(parseInt(res[0].ConfirmationNumber.slice(1)) + 1).padStart(
          6,
          '0'
        )}`;
      });
  }

  assignSelectedProduct() {
    return this.recommendationService.signupProduct
      ? this.recommendationService.signupProduct
      : JSON.parse(sessionStorage.getItem('signupProduct'));
  }

  validatePhone() {
    $('#phone').keypress(function (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
    });
  }

  mailMe(
    mail // <--- element on which you need to apply click
  ) {
    mail = document.createElement('a');
    mail.href = 'mailto:hello@honestgorilla.com?subject=Question&body=Hi';
    mail.click();
  }

  toggleShowPassword(password) {
    this.user_bot = !this.user_bot;
  }

  toggleShowconfirmPassword(password) {
    this.user_bot1 = !this.user_bot1;
  }

  createAccount(event, myForm, formValid) {
    if (formValid) {
      const letsGo = document.getElementsByTagName('html');
      letsGo[0].classList.add('letsgo');
      const questionnarieObj = !_.isEmpty(
        this.residentialService.userResponse.userResponses
      )
        ? JSON.stringify(this.residentialService.userResponse)
        : sessionStorage.getItem('userResponse');
      if (!this.validateCaptchaDetails()) return;
      const questionObj = sessionStorage.getItem('questionStatusObj');
      this.userObj = { ...this.userObj, ...{ questionStatusObj: questionObj } };
      this.userObj = this.residentialService.user
        ? {
            ...this.userObj,
            ...{ _id: this.residentialService.user.accountId },
          }
        : this.userObj;
      this.userObj.fName = this.userObj.fName.replace(/ +/g, ' ');
      this.userObj.lName = this.userObj.lName.replace(/ +/g, ' ');
      this.openModal();
      this.postUserResponsesApi(questionnarieObj, myForm);
    }
  }

  getErrorResponseAPI() {
    this.openSnackBar(this.statusText);
    this.userObj.emailId = '';
    this.userObj.confirmPassword = '';
    const phnum = this.userObj.phone;
  }

  navigateToUserSettings() {
    if (
      (this.signUpResult.data.questionStatusObj.enrollmentState &&
        this.signUpResult.data.questionStatusObj.enrollmentState ===
          'Quitted') ||
      this.signUpResult.data.questionStatusObj.questionStatus === 'Quitted'
    ) {
      this.router.navigate([
        'user-settings',
        this.signUpResult.data.hg_accountId,
      ]);
    }
  }

  redirectUrlForOtherEnergyProviders() {
    if (
      this.signUpResult.data.questionStatusObj.questionStatus === 'Completed'
    ) {
      this.router.navigate([
        'signuporder',
        this.signUpResult.data.hg_accountId,
      ]);
    }
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }

  redirectUrlForBulbProvider() {
    const postObject = this.postObjectBulbApi();
    this.saveEnrollmentOrderDetails(postObject);
  }

  redirectUrlForProntoProvider() {
    const postObject = this.postObjectBulbApi();
    this.saveEnrollmentOrderDetails(postObject);
  }

  postObjectBulbApi() {
    let serviceTypeDateDetails = this.getServiceTypeValues(),
      isGetOrderRes = false,
      isNotificationRes = false,
      contactInfo = JSON.parse(sessionStorage.getItem('userObj'));
    this.selectedProduct.energy_provider_image =
      this.providerContact.ProviderCloudLogo;
    const orderDetails = {
      order_no: null,
      hg_accountId: this.recommendationService.hg_accountId,
      ConfirmationNumber: this.confirmationNumber,
      status: 'Completed',
      isDepositRequired: '',
      webStatus: 'Completed',
      reason: '',
      creditCheckResults: '',
      customerId: '',
      enableSMSForHonest: 'Yes',
      enableSMSForChariot: '',
      ratePlanName: this.selectedProduct.product_key,
      serviceTypeDetails: serviceTypeDateDetails,
      contactInfo: {
        legalFirstName: this.userObj.fName,
        legalLastName: this.userObj.lName,
        emailId: this.userObj.emailId,
        phoneNo: this.userObj.phone,
        language: 'English',
        dob: '',
        authorizedRep: '',
      },
      esiid: '',
      invoiceType: '',
      promoDetails: {
        hearusOption: '',
        promoeCode: '',
      },
      privateDetails: {
        state: 'TX',
        license: '',
      },
      billingAddress: this.getBillingAddress(),
      isExpired: false,
      ReceivedPromocode: this.residentialService.promoCode,
      UsedPromocode:
        this.residentialService.promoCode === 'TAP' ? 'TAP' : 'GORILLA',
      selectedProduct: this.selectedProduct,
      expirationDate: this.serviceTypeExpireDate(
        serviceTypeDateDetails.switchDate
      ),
      Affiliate: sessionStorage.getItem('_Affiliate') == undefined || sessionStorage.getItem('_Affiliate') == '' || sessionStorage.getItem('_Affiliate') == null? "" : sessionStorage.getItem('_Affiliate'),
      AffiliatePromo: sessionStorage.getItem('_Promo') == undefined || sessionStorage.getItem('_Promo') == '' || sessionStorage.getItem('_Promo') == null? "" : sessionStorage.getItem('_Promo'),
      AffiliateID: sessionStorage.getItem('_AffiliateID') == undefined || sessionStorage.getItem('_AffiliateID') == '' || sessionStorage.getItem('_AffiliateID') == null? "" : sessionStorage.getItem('_AffiliateID'),
      QuestionId: sessionStorage.getItem('QuestionUserID') == undefined || sessionStorage.getItem('QuestionUserID') == '' || sessionStorage.getItem('QuestionUserID') == null? "" : sessionStorage.getItem('QuestionUserID')
    };
    return orderDetails;
  }

  getBillingAddress() {
    if (!_.isEmpty(this.userResponses)) {
      const addressObj = _.findWhere(this.userResponses, {
        fieldName: 'address',
      });
      const billAddress = {
        userAddress: this.getFormattedAddress(addressObj),
        apartment: addressObj.fieldValue.apartment,
        billingAddress: this.getFormattedAddress(addressObj),
        sameAsService: true,
      };
      return billAddress;
    }
  }

  getFormattedAddress(addressObj) {
    let temp_address = {};
    if (addressObj.fieldValue.formatedAddress) {
      let address = addressObj.fieldValue.formatedAddress.split(',');
      let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
      temp_address['street_address'] = address[0];
      temp_address['city'] = address[1] ? address[1].trim() : '';
      temp_address['state'] = state ? state : '';
      temp_address['zipcode'] = zipcode ? zipcode : '';
    }
    return temp_address;
  }

  serviceTypeExpireDate(startDate) {
    let term = this.selectedProduct.terms,
      expiredDate =
        startDate !== 'Priority Move-In' && startDate !== 'Standard Switch'
          ? new Date(startDate)
          : new Date();
    expiredDate.setMonth(expiredDate.getMonth() + parseInt(term));
    return this.suffixDateTimeToSelectedSwitchDate(expiredDate);
  }

  suffixDateTimeToSelectedSwitchDate(expiredDate) {
    var d = new Date(expiredDate);
    return (
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('/') +
      ' ' +
      [d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()].join(':')
    );
  }

  redirectUrlForNewSignup() {
    // For new signup flow we are redirecting to user-settings instead of ques for quit flow.
    // From notification user can able continue anc complete the rest of the questionnarie
    this.residentialService.currentId =
      this.signUpResult.data.questionStatusObj.questionStep;
    this.residentialService.messageService({
      nextId: this.signUpResult.data.questionStatusObj.questionStep,
      questionStatus: this.signUpResult.data.questionStatusObj.questionStatus,
    });
    const oldURL = sessionStorage.getItem('path');
    this.redirectToNavigateByUrl();
  }

  redirectToNavigateByUrl() {
    const redirectionLink = this.loadNavigateByUrl.find(
      (element) => element.key === sessionStorage.getItem('path')
    );
    if (redirectionLink === undefined)
      this.router.navigate([
        'user-settings',
        this.signUpResult.data.hg_accountId,
      ]);
    else this.router.navigateByUrl(redirectionLink.value);
  }

  getSuccessResponseAPI() {
    // myForm.resetForm();
    sessionStorage.setItem('userObj', JSON.stringify(this.signUpResult.data));
    this.recommendationService.hg_accountId =
      this.signUpResult.data.hg_accountId;
    this.recommendationService.userName =
    this.signUpResult.data.questionStatusObj != null ? this.signUpResult.data.questionStatusObj.userName : this.signUpResult.data.userName;
    localStorage.setItem(
      'userName',
      this.signUpResult.data.questionStatusObj != null ? this.signUpResult.data.questionStatusObj.userName : this.signUpResult.data.userName
    );
    this.residentialService.setUser({
      userName: this.signUpResult.data.questionStatusObj != null ? this.signUpResult.data.questionStatusObj.userName : this.signUpResult.data.userName,
      accountId: this.signUpResult.data.hg_accountId,
      emailId: this.signUpResult.data.emailId,
    });
    this.navigatePerProductSelected();
  }
  navigatePerProductSelected() {
    if (this.selectedProduct) {
      this.loadNavigationLinksForEnergyProviders[
        this.signUpResult.data.questionStatusObj.questionStatus === 'Completed'
          ? this.renameEnergyProviderName(this.selectedProduct.energy_provider)
          : 'Others'
      ]();
    } else this.navigateToUserSettings();
  }

  renameEnergyProviderName(itemName: string) {
    return itemName === 'Bulb' || itemName === 'Pronto Power'
      ? itemName.replace(/\s/g, '')
      : 'OtherProviders';
  }

  postUserResponsesApi(questionnarieObj, myForm) {
    const body = new HttpParams()
      .append('userObj', JSON.stringify(this.userObj))
      .append('a', 'internal')
      .append('questionnarieObj', questionnarieObj)
      .append('UserRequest', sessionStorage.getItem('widthoutQuestionUserRequest'));
    this.http.post(this.url + '/signup', body).subscribe((res: any) => {
      this.onCloseHandled();
      this.signUpResult = res;
      this.resetCaptcha = true;
      this.resetOldImageCaptcha();
      this.statusText = res.statusText;
      this.loadSignupResponses[
        this.signUpResult.statusCode === '002' ? 'Error' : 'Success'
      ]();
    });
  }

  saveEnrollmentOrderDetails(orderDetails) {
    const body = new HttpParams();
    body.append('orderDetails', JSON.stringify(orderDetails));
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      res;
      if (this.selectedProduct.energy_provider === 'Bulb')
        window.location.href = `https://join.bulb.com/?utm_source=HonestGorilla&utm_medium=pcw&utm_campaign=HonestGorilla`;
      else
        this.router.navigate([
          'prepaidoption',
          this.recommendationService.hg_accountId,
        ]);
    });
  }

  resetOldImageCaptcha() {
    const oldImg = document.getElementById(this.selectedId);
    if (oldImg) {
      oldImg.style.border = '';
    }
    document.getElementById('recaptchaTxt').classList.add('d-none');
    document.getElementById('recaptchaImg').classList.remove('d-none');
  }

  validateCaptchaDetails() {
    if (!this.captchaVerified) {
      const oldImg = document.getElementById(this.selectedId);
      if (oldImg) {
        oldImg.style.border = '';
      }
      this.captcha();
      alert('Invalid Captcha.');
      return false;
    }
    return true;
  }

  getServiceTypeValues() {
    try{

      let serviceType, expiredDate, responses, switchObj, serviceTypeObj;
      if (!_.isEmpty(JSON.parse(sessionStorage.getItem('userResponse'))) && JSON.parse(sessionStorage.getItem('userResponse')) != null)
      {
      responses = JSON.parse(sessionStorage.getItem('userResponse'));
      this.userResponses = responses.userResponses;
      this.residentialService.userResponse['userResponses'] = this.userResponses;
      if (!_.isEmpty(this.userResponses)) {
        switchObj = _.findWhere(this.userResponses, {
          res_question_id: '002',
        });
        serviceType = switchObj.fieldValue;
        serviceTypeObj =
          this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
        expiredDate = this.expiratonDateFromQuestion();
      }
      return {
        serviceType: serviceType,
        switchType: serviceTypeObj.switchType,
        switchDate: serviceTypeObj.startDate,
        moveInType: serviceTypeObj.switchType,
        expiredDate: expiredDate,
      };
    }else
    {
  
      var responses__ = JSON.parse(sessionStorage.getItem('sevrviceDetails'));
      //this.userResponses = responses.userResponses;
      //this.residentialService.userResponse['userResponses'] = this.userResponses;
      if (!_.isEmpty(responses__)) {
        switchObj = _.findWhere(responses__, {
          res_question_id: '002',
        });
        serviceType = switchObj.fieldValue;
        serviceTypeObj =
          this.loadServiceTypeObject[switchObj.fieldValue.replace(/\s/g, '')]();
        expiredDate = this.expiratonDateFromQuestion();
      }
      return {
        serviceType: serviceType,
        switchType: serviceTypeObj.switchType,
        switchDate: serviceTypeObj.startDate,
        moveInType: serviceTypeObj.switchType,
        expiredDate: expiredDate,
      };
    }
    }catch{
      return {
        serviceType: "New Service",
        switchType: "New Service",
        switchDate: this.getServiceTypeDateObj( new Date()),
        expiredDate: "",
      };
    }
   
  }

  expiratonDateFromQuestion() {
    let expiredDate;
    const expireObj = _.findWhere(this.userResponses, {
      res_question_id: '003',
    });
    if (!_.isEmpty(expireObj) && typeof expireObj.fieldValue !== 'string') {
      const date = JSON.parse(expireObj.fieldValue.date);
      expiredDate = this.getServiceTypeDateObj(date);
    } else if (
      !_.isEmpty(expireObj) &&
      typeof expireObj.fieldValue === 'string'
    ) {
      expiredDate = expireObj.fieldValue;
    }
    return expiredDate !== undefined ? expiredDate : '';
  }

  assignServiceTypeValuesForStandardSwitch(): any {
    const obj = _.findWhere(this.userResponses, { res_question_id: '004' });
    let startDate,
      switchType = obj.fieldValue;
    if (switchType === 'Standard Switch') {
      startDate = 'Standard Switch';
    } else {
      const dateObj = _.findWhere(this.userResponses, {
        res_question_id: '005',
      });
      startDate = this.getServiceTypeDateObj(dateObj.fieldValue);
    }
    return { switchType: switchType, startDate: startDate };
  }

  assignServiceTypeValuesForNewService() {
    const switchDateObj = _.findWhere(this.userResponses, {
      res_question_id: '007',
    });
    let switchType, startDate;
    if (!_.isEmpty(switchDateObj)) {
      switchType = switchDateObj.startDateType;
      if (
        switchDateObj.startDateType &&
        switchDateObj.startDateType === 'Priority Move-In'
      ) {
        startDate = 'Priority Move-In';
      } else {
        const someDate = new Date();
        someDate.setDate(someDate.getDate() + 2);
        startDate =
          new Date(switchDateObj.fieldValue) < someDate
            ? 'Priority Move-In'
            : this.getServiceTypeDateObj(switchDateObj.fieldValue);
      }
    }
    return { switchType: switchType, startDate: startDate };
  }

  getServiceTypeDateObj(dateObj) {
    return (
      this.pad(new Date(dateObj).getMonth() + 1) +
      '/' +
      new Date(dateObj).getDate() +
      '/' +
      new Date(dateObj).getFullYear()
    );
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  // for captcha vaidation
  captcha = function () {
    this.flag = true;
    const evaExpression = new Array(
      'Cheesy Smile',
      'Lightbulb Moment',
      'Sad',
      'Thumbs Up',
      'Wink',
      'Wonderment'
    );
    let i;
    let txt = '';
    for (i = 0; i < 1; i++) {
      txt =
        txt +
        evaExpression[Math.floor(Math.random() * evaExpression.length)] +
        ' ';
    }
    this.evaTxt = txt;
  };

  checkPswd = function () {
    this.passwordMismatch = false;
    const string1 = this.removeSpaces(this.userObj.password);
    const string2 = this.removeSpaces(this.userObj.confirmPassword);
    if (JSON.stringify(string1) === JSON.stringify(string2)) {
      this.passwordMismatch = true;
      this.flag = false;
      return true;
    } else {
      this.passwordMismatch = false;
      this.flag = true;
      // this.userObj.confirmPassword = '';
      return false;
    }
  };

  closebtn() {
    window.history.back();
  }

  // To change the image
  changeImage(id) {
    // to remove the border for existing img
    const oldImg = document.getElementById(this.selectedId);
    if (oldImg) {
      oldImg.style.border = '';
    }
    const imgTag = document.getElementById(id);
    imgTag.style.border = '2px solid #ed1976';
    imgTag.style.borderRadius = '.4rem';
    this.selectedTxt = imgTag['alt'];
    this.selectedId = id;
    const string1 = this.removeSpaces(this.evaTxt.toLowerCase());
    const string2 = this.removeSpaces(this.selectedTxt.toLowerCase());
    if (string1 === string2) {
      this.captchaVerified = true;
      document.getElementById('recaptchaImg').classList.add('d-none');
      document.getElementById('recaptchaTxt').classList.remove('d-none');
      this.flag =
        (this.userObj.password &&
          this.userObj.confirmPassword &&
          this.userObj.password != this.userObj.confirmPassword) ||
        this.userObj.password === '' ||
        this.userObj.confirmPassword === '';
    } else {
      this.captchaVerified = false;
      alert('Invalid captcha.');
      const slctdImg = document.getElementById(this.selectedId);
      if (slctdImg) {
        slctdImg.style.border = '';
      }
      this.captcha();
    }
  }

  removeSpaces = function (string) {
    return string.split(' ').join('');
  };

  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  // Phone number validation
  pNumberValidation(e) {
    const text = e.target.value;
    if (text.length === 3 && e.key !== 'Backspace' && e.key !== 'Delete') {
      this.userObj.phone = text + '-';
    }
    if (text.length === 7 && e.key !== 'Backspace' && e.key !== 'Delete') {
      this.userObj.phone = text + '-';
    }
  }

  // handling the gmail authentication flow
  getAuthenticate(url) {
    const questionnarieObj = sessionStorage.getItem('userResponse');
    const questionStatusObj = sessionStorage.getItem('questionStatusObj');
    const UserRequest = sessionStorage.getItem('widthoutQuestionUserRequest');
    let body = new HttpParams()
      .set('a', 'external')
      .set('questionnarieObj', questionnarieObj)
      .set('questionStatusObj', questionStatusObj)
      .set('type', JSON.stringify('signup'))
      .set('UserRequest', UserRequest);
    body = !_.isEmpty(this.residentialService.user)
      ? body.set(
          'accountId',
          JSON.stringify(this.residentialService.user.accountId)
        )
      : body.set('accountId', this.recommendationService.hg_accountId);
    this.http
      .post(this.url + '/getUserResponse', body)
      .subscribe((res: any) => {
        if (this.selectedProduct)
          sessionStorage.setItem(
            'orderDetails',
            JSON.stringify(this.postObjectBulbApi())
          );
        window.location.href = environment.api_url + url;
      });
  }

  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }

  getCompareDetails() {
    const user = JSON.parse(sessionStorage.getItem('userDetails'));
    this.router.navigate(['/recommendation/compare-product', user.accountId]);
  }

  openSnackBar(statusText) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 30000,
      data: {
        name: statusText,
        title: 'Error',
      },
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: 'bg-danger',
    });
  }

  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    // append to head of document
    
    document.getElementsByTagName('head')[0].appendChild(node); 
  
    let script = this._renderer2.createElement('script');
    script.setAttribute('id', 'ChatScript');
    script.text = `
        (function(d, w, c) {
          w.BrevoConversationsID = '649dacacdbc74231a94a3297';
          w[c] = w[c] || function() {
              (w[c].q = w[c].q || []).push(arguments);
          };
          var s = d.createElement('script');
          s.async = true;
          s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
          if (d.head) d.head.appendChild(s);
      })(document, window, 'BrevoConversations');
    `;
  
    const existingScript = document.getElementById("ChatScript");
    if (!existingScript) {
      
    document.getElementsByTagName('head')[0].appendChild(script); 
    }
  }
}
